module.exports = __webpack_public_path__ + "img/practical-fixer.6692ee2d.svg";